/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import StringResources from 'nls/StringResources';

/**
* Helper class to encapsulate logic around getting data for rendering 'Combined' calculations column in
* compare summary table
*
*/
export default class CalculatedChartDetail {
	constructor(props) {
		this.process(props);
	}
	process(props) {
		const summaryModel = props.summaryModel;
		const widgets = summaryModel.charts || [];
		const getChartSummaryStats = props.getChartSummaryStats;

		const allWidgetsStats = [];
		widgets.forEach( (widgetInfo) => {
			const chartSumStats = getChartSummaryStats(widgetInfo.widgetId, widgetInfo.measureName);
			if (chartSumStats) {
				allWidgetsStats.push(chartSumStats);
			}
		});

		void(summaryModel.widgetContextProcessState); //re-render if state changes
		const calculatedData = summaryModel.getCalculatedData(allWidgetsStats) || [];

		this.cellRenderer = (row) =>{
			return { value : calculatedData[row].value, valueUse : calculatedData[row].valueUse, toolTip: calculatedData[row].toolTip };
		};
		this.headerRenderer = () => {
			return { label: StringResources.get('compareTable_CalculatedStatsHeader') };
		};
	}
}



// WEBPACK FOOTER //
// ./src/js/components/lwstats/CalculatedChartDetail.js